import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { TableRegionTileFragment } from "../../client/generated";
import { assertTypeName } from "../../client/guards";
import { RegionTile } from "../../regions/RegionTile";
import { getTableFromRegion } from "../../tables/utils";

type Props = {
  fragment: TableRegionTileFragment;
  tableAttributeId: string;
  children: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function TableRegionTile({
  fragment,
  tableAttributeId,
  children,
  dispatch,
}: Props) {
  const tableAttribute = fragment.attributes.find(
    (a) => a.id === tableAttributeId,
  );
  assertTypeName(tableAttribute?.__typename === "TableAttribute");

  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
      table: getTableFromRegion(fragment),
    });
  };

  return (
    <RegionTile
      fragment={fragment}
      preview={`${tableAttribute.rows.length}⨯${tableAttribute.columns.length}`}
      onClick={onClick}
    >
      {children}
    </RegionTile>
  );
}
